module.exports = __webpack_public_path__ + "img/0003.d0fa9dff.png";